import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import EditSurvey from "./EditSurvey";
import { format } from "date-fns";
import Table from "../layouts/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  addSurvey,
  resetSurvey,
  updateAllSurveys,
} from "../../redux/surveySlice";
import Dropdown from "react-bootstrap/Dropdown";
import {
  closeEditSurveyModal,
  modalSelector,
  openSurveyModal,
} from "../../redux/modalSlice";
import { pascalCase } from "pascal-case";
import { deleteSurvey } from "../../redux/surveySlice";
import DeleteSurvey from "../admin-component/survey/DeleteSurvey";

const TableSurveyList = ({
  survey,
  searchText,
  getSurveys,
  paginate,
  statusUpdate,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { modal } = useSelector(modalSelector);
  const [checked, setChecked] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [surveyId, setSurveyId] = useState();

  const headers = [
    {
      Header: () => (
        <>
          <input
            type="checkbox"
            className="checkbox-style"
            checked={checked}
            onChange={() => checkAll()}
            id="checkbox"
            name="structure"
          />
          <label htmlFor="checkbox" className="align-items-center"></label>
        </>
      ),
      accessor: "check",
      disableSortBy: true,
      Cell: (props) => {
        return (
          <>
            <input
              type="checkbox"
              className="checkbox-style"
              checked={props.row.original.checked}
              onChange={() => handleChecked(props.row.original)}
              id={props.row.original.id}
              name="structure"
            />
            <label
              htmlFor={props.row.original.id}
              className="align-items-center"
            ></label>
          </>
        );
      },
    },
    {
      Header: "WHE Ref.",
      accessor: "wheRef",
      Cell: (props) => {
        return (
          <p
            onClick={() => navigate(`/survey-detail/${props.row.original.id}`)}
          >
            {props.row.original.wheRef}
          </p>
        );
      },
    },
    {
      Header: "Inspection Order",
      accessor: "hdcAssetReference",
      Cell: (props) => {
        return (
          <p
            className="name"
            onClick={() => navigate(`/survey-detail/${props.row.original.id}`)}
          >
            {props.row.original.hdcAssetReference}
          </p>
        );
      },
    },
    {
      Header: "Assigned To",
      accessor: "surveyorName",
      Cell: (props) => {
        return (
          <p
            className="address"
            onClick={() => navigate(`/survey-detail/${props.row.original.id}`)}
          >
            {props.row.original.surveyorName}
          </p>
        );
      },
    },
    {
      Header: "Inspection Date",
      accessor: "inspectionDate",
      Cell: (props) => {
        return props.row.original.inspectionDate
          ? format(
              new Date(props.row.original.inspectionDate),
              "MMM dd, yyyy"
            )
          : "";
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        return (
          <Dropdown align="end">
            <Dropdown.Toggle
              variant={`label ${
                props.row.original.status === "published"
                  ? "label-publish"
                  : props.row.original.status === "submitted"
                  ? "label-primary"
                  : props.row.original.status === "accepted"
                  ? "label-accepted"
                  : "label-warning"
              }`}
              id="dropdown-basic"
            >
              {pascalCase(props.row.original.status || "draft")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                href="#"
                onClick={() => statusUpdate(props, "draft")}
              >
                Draft
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => statusUpdate(props, "submitted")}
              >
                Submitted
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => statusUpdate(props, "accepted")}
              >
                Accepted
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                onClick={() => statusUpdate(props, "published")}
              >
                Published
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
    {
      Header: "Delete",
      accessor: "edit",
      Cell: (props) => {
        return (
          <ul className="actionTable">
            <li>
              <Link to="#" className="edit">
                <Icon
                  icon="ic:outline-delete-outline"
                  onClick={() => {
                    setModalShow(true);
                    setSurveyId(props.row.original);
                    // dispatch(openEditSurveyModal());
                    // dispatch(
                    //   addSurvey({
                    //     ...props.row.original,
                    //     wheRef: props.row.original.wheRef.split("/")[1],
                    //   })
                    // );
                  }}
                />
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];

  useEffect(() => {
    let surveys = survey?.data ? [...survey?.data] : [];
    if (surveys.filter((sur) => sur.checked).length === surveys.length) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [survey.data]);

  const checkAll = () => {
    let surveys = [...survey?.data];
    surveys = surveys?.map((sur) => {
      let temp = { ...sur };
      temp.checked = !checked;
      return temp;
    });
    setChecked(!checked);
    dispatch(updateAllSurveys(surveys));
  };

  const handleChecked = (e) => {
    let surveys = [...survey.data];
    surveys = surveys.map((sur) => {
      let temp = { ...sur };
      if (temp.id === e.id) {
        temp.checked = !temp.checked;
      }
      return temp;
    });
    dispatch(updateAllSurveys(surveys));
  };

  const surveyDelete = async (survey) => {
    setModalShow(false);
    dispatch(deleteSurvey(survey));
  };

  return (
    <>
      {survey.data && (
        <Table
          headers={headers}
          totalCount={survey.count}
          getData={getSurveys}
          paginate={paginate}
          searchText={searchText}
          gridData={survey.data}
          isSearchAble={true}
          selected="No survey added"
          content="It seems like you have not created any survey yet! Create one and view the content here."
          addNew="Add new survey"
          onAdd={() => {
            dispatch(resetSurvey());
            dispatch(openSurveyModal());
          }}
        />
      )}
      <EditSurvey
        show={modal.editSurvey}
        onHide={() => dispatch(closeEditSurveyModal())}
      />
      <DeleteSurvey
        show={modalShow}
        onHide={() => setModalShow(false)}
        onRemove={() => surveyDelete(surveyId)}
      />
    </>
  );
};

export default TableSurveyList;
